import { render } from "./ModalTransferUsdtAccept.vue?vue&type=template&id=32291508&scoped=true&ts=true"
import script from "./ModalTransferUsdtAccept.vue?vue&type=script&lang=ts"
export * from "./ModalTransferUsdtAccept.vue?vue&type=script&lang=ts"

import "./ModalTransferUsdtAccept.vue?vue&type=style&index=0&id=32291508&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32291508"]])

export default __exports__